import { render, staticRenderFns } from "./DownLoadTable1.vue?vue&type=template&id=0b729411&scoped=true&"
import script from "./DownLoadTable1.vue?vue&type=script&lang=js&"
export * from "./DownLoadTable1.vue?vue&type=script&lang=js&"
import style0 from "./DownLoadTable1.vue?vue&type=style&index=0&id=0b729411&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b729411",
  null
  
)

export default component.exports